import { useIxmTriggerV1TriggerQueryServiceTriggerGet } from '@interxfi/api-client/generated/hooks/ixm-trigger-v1-trigger-query-service-trigger-get';
import { getShortenedId } from '@interxfi/design-system/components/format/id/shared';
import { Skeleton } from '@interxfi/design-system/components/loading/skeleton';

interface TriggerBreadcrumbProps {
  triggerId: string;
}

export function TriggerBreadcrumb({ triggerId }: TriggerBreadcrumbProps) {
  const { data, error, isPending } = useIxmTriggerV1TriggerQueryServiceTriggerGet({ triggerId });
  const showPending = Boolean(isPending || error);

  if (showPending) {
    return <Skeleton charCount={8} />;
  }

  return data?.trigger?.data?.triggerName || `Trigger ${getShortenedId(triggerId)}`;
}
